/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DocArrowOutIcon16Solid = forwardRef('DocArrowOutIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M4.5 1H8v3.5A1.5 1.5 0 0 0 9.5 6h2.596a2.54 2.54 0 0 0-1.43.838 2.543 2.543 0 0 0-.602 1.928A5.75 5.75 0 0 0 4.75 14.5v.5H4.5A2.5 2.5 0 0 1 2 12.5v-9A2.5 2.5 0 0 1 4.5 1Z" }),
        React.createElement("path", { d: "M13 5H9.5a.5.5 0 0 1-.5-.5V1l4 4Z" }),
        React.createElement("path", { d: "M10.5 12.025a2.625 2.625 0 0 0-2.625 2.625V15a.875.875 0 0 1-1.75 0v-.35a4.375 4.375 0 0 1 4.375-4.375h2.648l-1.118-.961a.875.875 0 1 1 1.14-1.328l2.027 1.742c.87.748.87 2.096 0 2.844l-2.027 1.742a.875.875 0 1 1-1.14-1.328l1.119-.961H10.5Z" })));
});
